import { PROFILE_TYPES } from '@/utils/enums';

export default [
    {
        path: '/developer',
        component: () => import('@/views/developer'),
        name: 'developer.home',
        meta: { auth: true },
        children: [
            {
                path: 'apps',
                name: 'developer.apps',
                component: () => import('@/views/developer/app/index.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'apps/:alias',
                name: 'developer.apps.detail',
                component: () => import('@/views/developer/app/detail.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'partner-environment',
                name: 'developer.partner-environment',
                component: () => import('@/views/developer/partner-environment/index.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'apps/:alias/basic-config',
                name: 'developer.apps.basic-config',
                component: () => import('@/views/developer/app/basic_config.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'apps/:alias/config',
                name: 'developer.apps.config',
                component: () => import('@/views/developer/app/config.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'apps/:alias/submit',
                name: 'developer.apps.submit',
                component: () => import('@/views/developer/app/submit.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'apps/:alias/submit-version',
                name: 'developer.apps.submit-version',
                component: () => import('@/views/developer/app/submit_version.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'apps/:alias/review',
                name: 'developer.apps.review',
                component: () => import('@/views/developer/app/submit_version.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'apps/:alias/status',
                name: 'developer.apps.status',
                component: () => import('@/views/developer/app/status.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'apps/:alias/solicitation/:solicitationId',
                name: 'developer.apps.solicitation.detail',
                component: () => import('@/views/developer/app/submit.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
            {
                path: 'apps/:alias/reviews',
                name: 'developer.apps.reviews',
                component: () => import('@/views/developer/app/review.vue'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.DEVELOPER] },
            },
        ],
    },
];
